import { BillingPlansTableMixin } from '../../mixins/plans.mixin';
import { FormValidationMixin } from '../../mixins/validation.mixin';
import { not, required, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'
import { regex } from "vuelidate/lib/validators/common";

const elem = '#register';
const RegistrationPage = {
    el: elem,
    mixins: [BillingPlansTableMixin, FormValidationMixin],
    data: {
        form: {
            email: '',
            name: '',
            phone: '',
            username: '',
            password: '',
            password_confirmation: '',
            voucher: '',
            accept_terms: '',
        },
    },
    validations: {
        form: {
            // Copied the email regex from the latest vuelidate source as the current version (0.7.6) doesn't support case-insensitive
            // Once there's a new stable release, this can be reverted to using the `email` validator provided by the package.
            email: { required, regex: regex('email', /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i) },
            name: { required, maxLength: maxLength(255) },
            phone: { required, regex: regex('regex', /^\d+$/) }, 
            username: { required, minLength: minLength(5), maxLength: maxLength(30), regex: regex('regex', /^[a-zA-Z0-9]{5,}$/) },
            password: { required, minLength: minLength(8), maxLength: maxLength(30), regex_password: regex('regex_password', /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*\-_~]).{8,}$/) },
            password_confirmation: { sameAs: sameAs('password') },
            accept_terms: { required,  not: not( () => '') }
        }
    },
	mounted() {

        if (this.$el.dataset.plan) {
            this.selected_plan = this.options[this.plans.indexOf(this.$el.dataset.plan)];
        } else {
            this.selected_plan = this.options[1];
        }

        if (this.$el.dataset.email) {
            this.form.email = this.$el.dataset.plan;
        }

        if (this.$el.dataset.old) {
            let old = JSON.parse(this.$el.dataset.old);

            this.form = {
                email: old.email || this.$el.dataset.email || '',
                name: old.name || '',
                phone: old.phone || '',
                username: old.username || '',
                password: old.password || '',
                password_confirmation: old.password_confirmation || '',
                voucher: old.voucher || this.$el.dataset.promo || '',
                accept_terms: old.accept_terms || '',
            }
        }
    },
    methods: {
        validateForm($e) {

            this.$v.$touch();

            if (this.$v.$invalid) {
                if (this.upsell_modal) {
                    this.upsell_modal = false;
                }
                if (this.changing_plan) {
                    this.changing_plan = false;
                }
                if (this.confirm_plan_selected) {
                    this.confirm_plan_selected = false;
                }
                return;
            }

            if ($e.target.id === 'reg_step_2') this.upsell_modal = true

            if ($e.target.tagName === 'FORM') $e.target.submit();

        }
    },
    computed: {},
    watch: {},
    components: {}
};

if ($(elem)) {
    new Vue(RegistrationPage);
}
